import { Cotacoes } from './pages/Cotacoes';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthService } from './services/authService';
import { Dashboard } from './pages/Dashboard';
import { Clientes } from './pages/Clientes';
import { Apolice } from './pages/Apolice';
import ClientesFormWrapper from './pages/ClientesFormWrapper';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { NotifierProvider } from './components/ui/Notifier';
import { AixaDashboard } from './components/dashboard/AixaDashboard';
import { Login } from './components/auth/Login';
import Home from './pages/Home';
import EmpresaCreate from './pages/EmpresaCreate';
import Importacoes from './pages/Importacoes';
import CadastroEmpresaGrupo from './pages/CadastroEmpresaGrupo';
import { Configuracoes } from './pages/Configuracoes';
import { Produtos } from './pages/Produtos';
import { Seguradoras } from './pages/Seguradoras';
import { Situacoes } from './pages/Situacoes';
import AgendamentosPage from './pages/Agendamentos';
import SinistrosPage from './pages/Sinistros';
import RepassesPage from './pages/Repasses';
import { RepassesPorDocumento } from './pages/RepassesPorDocumento';
import ParcelasPage from './pages/Parcelas';
import { MetasComissao } from './pages/MetasComissao';
import MetaComissaoReport from './pages/MetaComissaoReport';
import { EmpresaProvider } from './contexts/EmpresaContext';
import DigisacPage from './pages/Digisac';

function App() {
  return (
    <Router>
      <EmpresaProvider>
        <NotifierProvider>
      <Routes>
        {/* Rota de login pública */}
        <Route path="/login" element={<Login />} />
        
        {/* Root - enviar para home se autenticado, senão para login */}
        <Route
          path="/"
          element={AuthService.isAuthenticated() ? <Navigate to="/home" replace /> : <Navigate to="/login" replace />}
        />

        {/* Home - Rota principal protegida */}
        <Route 
          path="/home" 
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          } 
        />

        {/* Dashboard AIXA - Rota protegida (mantida em /dashboard) */}
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <AixaDashboard />
            </ProtectedRoute>
          } 
        />
        
        {/* Dashboard original - mantido para compatibilidade */}
        <Route 
          path="/dashboard-original" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />
        
        {/* Rotas de clientes - disponíveis para todos os usuários autenticados */}
        <Route 
          path="/clientes" 
          element={
            <ProtectedRoute>
              <Clientes />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/clientes/novo" 
          element={
            <ProtectedRoute>
              <ClientesFormWrapper />
            </ProtectedRoute>
          } 
        />

        {/* Rota para criar empresa - apenas Master/Grupo */}
        <Route
          path="/empresas/novo"
          element={
            <ProtectedRoute requireAnyOf={["master", "grupo"]}>
              <EmpresaCreate />
            </ProtectedRoute>
          }
        />

        {/* Rota para cadastro de empresa/grupo - apenas Master */}
        <Route
          path="/cadastro"
          element={
            <ProtectedRoute requireAnyOf={["master"]}>
              <CadastroEmpresaGrupo />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/clientes/:id/editar" 
          element={
            <ProtectedRoute>
              <ClientesFormWrapper />
            </ProtectedRoute>
          } 
        />
        
        {/* Rota de apólice - disponível para todos os usuários autenticados */}
        <Route 
          path="/apolice" 
          element={
            <ProtectedRoute>
              <Apolice />
            </ProtectedRoute>
          } 
        />

        {/* Novas páginas: Agendamentos / Sinistros / Repasses */}
        <Route
          path="/agendamentos"
          element={
            <ProtectedRoute>
              <AgendamentosPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/digisac"
          element={
            <ProtectedRoute>
              <DigisacPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/sinistros"
          element={
            <ProtectedRoute>
              <SinistrosPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/repasses"
          element={
            <ProtectedRoute>
              <RepassesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/repasses-por-documento"
          element={
            <ProtectedRoute>
              <RepassesPorDocumento />
            </ProtectedRoute>
          }
        />

        <Route
          path="/parcelas"
          element={
            <ProtectedRoute>
              <ParcelasPage />
            </ProtectedRoute>
          }
        />

        {/* Metas de Comissão - página dedicada */}
        <Route
          path="/metas-comissao"
          element={
            <ProtectedRoute>
              <MetasComissao />
            </ProtectedRoute>
          }
        />

        {/* Relatório de Metas (comparação por produto) */}
        <Route
          path="/meta-comissao-report"
          element={
            <ProtectedRoute>
              <MetaComissaoReport />
            </ProtectedRoute>
          }
        />

        {/* Importações - página dedicada */}
        <Route
          path="/importacoes"
          element={
            <ProtectedRoute>
              <Importacoes />
            </ProtectedRoute>
          }
        />

        {/* Configurações - página dedicada */}
        <Route
          path="/configuracoes"
          element={
            <ProtectedRoute>
              <Configuracoes />
            </ProtectedRoute>
          }
        />

        {/* Gestão de Produtos */}
        <Route
          path="/produtos"
          element={
            <ProtectedRoute>
              <Produtos />
            </ProtectedRoute>
          }
        />

        {/* Gestão de Seguradoras */}
        <Route
          path="/seguradoras"
          element={
            <ProtectedRoute>
              <Seguradoras />
            </ProtectedRoute>
          }
        />

        {/* Gestão de Situações */}
        <Route
          path="/situacoes"
          element={
            <ProtectedRoute>
              <Situacoes />
            </ProtectedRoute>
          }
        />

        {/* Página de Cotações */}
        <Route
          path="/cotacoes"
          element={
            <ProtectedRoute>
              <Cotacoes />
            </ProtectedRoute>
          }
        />
        
        {/* Rota catch-all - redireciona para login se não estiver autenticado */}
        <Route 
          path="*" 
          element={
            <ProtectedRoute>
              <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="text-center">
                  <h1 className="text-2xl font-bold text-gray-900 mb-2">
                    Página não encontrada
                  </h1>
                  <a 
                    href="/home" 
                    className="text-indigo-600 hover:text-indigo-500"
                  >
                    Voltar ao Home
                  </a>
                </div>
              </div>
            </ProtectedRoute>
          } 
        />
      </Routes>
        </NotifierProvider>
      </EmpresaProvider>
    </Router>
  );
}

export default App;